// src/components/AssetScopeBar.jsx
//
// Layout route for the asset-scoped sections (Data & Forecasts, Feasibility
// Study, Historic Runs / Bid Schedules): a slim bar naming the asset whose
// configuration the pages below are reading, with the switcher. The pages
// themselves are unchanged.

import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import { useFile } from "../context/FileContext";
import AssetSelect from "./AssetSelect";
import { isOperationsLocation } from "../navigation/sections";

export default function AssetScopeBar({ opsAware = false }) {
  const { assets } = useFile();
  const location = useLocation();
  // /dashboard hosts both Data & Forecasts views and two Operations views
  // (Historic Runs, Bid Schedules); the latter are portfolio pages and get no
  // asset bar.
  if (opsAware && isOperationsLocation(location)) {
    return <Outlet />;
  }
  return (
    <Box>
      {assets?.length > 0 && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          useFlexGap
          sx={{
            flexWrap: "wrap",
            px: { xs: 1.5, md: 3 },
            py: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <AssetSelect minWidth={{ xs: 0, sm: 300 }} maxWidth={560}
            sx={{ width: { xs: "100%", sm: "auto" } }} />
        </Stack>
      )}
      <Outlet />
    </Box>
  );
}
